import { ObjectTypeEnum } from "../../types/SubCondition"
import { LocalizedText } from "../Localization/LocalizationTypes"

export interface CustomFieldValue {
    key: string
    value: string
}

export interface CustomFieldTypeFromService {
    fieldEId: string
    fieldType: CustomFieldTypes
    objectType: 'Candidate' | 'Job'
    name: string
    values?: Array<CustomFieldValue>
}

export interface CustomFieldServiceData {
    candStandard: {
        [key: string]: Array<CustomFieldTypeFromService>
    },
    jobStandard: {
        [key: string]: Array<CustomFieldTypeFromService>
    }
}

export interface CustomFieldsContextState {
    customFields: {
        candidateFields: Array<CustomFieldTypeFromService>
        jobFields: Array<CustomFieldTypeFromService>
    }
    loading: boolean
    error: string
    getCandidateField: (fieldEId: string) => CustomFieldTypeFromService
    getJobField: (fieldEId: string) => CustomFieldTypeFromService
}

export type CustomFieldTypes = 'Date' | 'Number' | 'Currency' | 'Amount' | 'CheckBox' | 'DropDown' | 'Radio' | 'Employee' | 'EmployeeNoDefault'

export const SELECTABLE_FIELD_TYPES_MAP = {
    [ObjectTypeEnum.Candidate]: 'Candidate',
    [ObjectTypeEnum.Requisition]: 'Requisition',
} as const

export const OBJECT_TYPE_MAP = {
    [ObjectTypeEnum.NOT_SET]: '',
    [ObjectTypeEnum.Candidate]: 'Candidate',
    [ObjectTypeEnum.Requisition]: 'Job',
} as const

export const OBJECT_TYPE_PAYLOAD_MAP = {
    '': ObjectTypeEnum.NOT_SET,
    'Job': ObjectTypeEnum.Requisition,
    'Candidate': ObjectTypeEnum.Candidate,
}

export type StatementOperatorTypes = 'GREATER_THAN' | 'LESS_THAN' | 'EQUALS' | 'NOT_EQUALS' | 'BETWEEN' | 'NOT_BETWEEN' | 'ANY' | 'NONE' | 'SPECIFIC_DATE' | 'CUSTOM_RANGE' | 'BEFORE' | 'AFTER'

export const FIELD_STATEMENT_OPERATORS = {
    'Currency': [
        { key: 'GREATER_THAN', translation: LocalizedText.OperatorGreaterThan },
        { key: 'LESS_THAN', translation: LocalizedText.OperatorLessThan },
        { key: 'EQUALS', translation: LocalizedText.OperatorEqual },
        { key: 'NOT_EQUALS', translation: LocalizedText.OperatorNotEqual },
        { key: 'BETWEEN', translation: LocalizedText.OperatorBetween },
        { key: 'NOT_BETWEEN', translation: LocalizedText.OperatorNotBetween },
    ],
    'Number': [
        { key: 'GREATER_THAN', translation: LocalizedText.OperatorGreaterThan },
        { key: 'LESS_THAN', translation: LocalizedText.OperatorLessThan },
        { key: 'EQUALS', translation: LocalizedText.OperatorEqual },
        { key: 'NOT_EQUALS', translation: LocalizedText.OperatorNotEqual },
        { key: 'BETWEEN', translation: LocalizedText.OperatorBetween },
        { key: 'NOT_BETWEEN', translation: LocalizedText.OperatorNotBetween },
    ],
    'Amount': [
        { key: 'GREATER_THAN', translation: LocalizedText.OperatorGreaterThan },
        { key: 'LESS_THAN', translation: LocalizedText.OperatorLessThan },
        { key: 'EQUALS', translation: LocalizedText.OperatorEqual },
        { key: 'NOT_EQUALS', translation: LocalizedText.OperatorNotEqual },
        { key: 'BETWEEN', translation: LocalizedText.OperatorBetween },
        { key: 'NOT_BETWEEN', translation: LocalizedText.OperatorNotBetween },
    ],
    'CheckBox': [
        { key: 'ANY', translation: LocalizedText.OperatorAny },
        { key: 'NONE', translation: LocalizedText.OperatorNone },
    ],
    'Employee': [
        { key: 'ANY', translation: LocalizedText.OperatorAny },
        { key: 'NONE', translation: LocalizedText.OperatorNone },
    ],
    'EmployeeNoDefault': [
        { key: 'ANY', translation: LocalizedText.OperatorAny },
        { key: 'NONE', translation: LocalizedText.OperatorNone },
    ],
    'Date': [
        { key: 'SPECIFIC_DATE', translation: LocalizedText.OperatorSpecificDate },
        { key: 'CUSTOM_RANGE', translation: LocalizedText.OperatorCustomRange },
        { key: 'BEFORE', translation: LocalizedText.OperatorBefore },
        { key: 'AFTER', translation: LocalizedText.OperatorAfter },
    ],
    'DropDown': [
        { key: 'ANY', translation: LocalizedText.OperatorAny },
        { key: 'NONE', translation: LocalizedText.OperatorNone },
    ],
    'Radio': [
        { key: 'ANY', translation: LocalizedText.OperatorAny },
        { key: 'NONE', translation: LocalizedText.OperatorNone },
    ]
} as const